module.exports = __webpack_public_path__ + "img/star.ab287251.svg";